const Types = [
  {
    id: 1,
    name: 'Internal',
    label: 'Internal',
  },
  {
    id: 2,
    name: 'External',
    label: 'External',
  },
];

export default Types;
